import { Font, Document } from "@react-pdf/renderer";
import logo from "../logos/logo.png";
import { ResumeFr, ResumeEn, ResumeNl } from "./Resume";

Font.register({
  family: "Open Sans",
  src: `https://fonts.gstatic.com/s/opensans/v17/mem8YaGs126MiZpBA-UFVZ0e.ttf`,
});

Font.register({
  family: "Poppins",
  src: `https://fonts.gstatic.com/s/poppins/v1/VIeViZ2fPtYBt3B2fQZplvesZW2xOQ-xsNqO47m55DA.ttf`,
});

Font.register({
  family: "Poppins Italic",
  src: `https://fonts.gstatic.com/s/poppins/v1/4WGKlFyjcmCFVl8pRsgZ9vesZW2xOQ-xsNqO47m55DA.ttf`,
});

Font.register({
  family: "Poppins Bold",
  src: `https://fonts.gstatic.com/s/poppins/v1/-zOABrCWORC3lyDh-ajNnPesZW2xOQ-xsNqO47m55DA.ttf`,
});

const TicketModel = (props) => {
  const { lang } = props;

  const ResumeComponent = lang === "fr" ? ResumeFr : lang === "nl" ? ResumeNl : ResumeEn;

  if (props.subdivision) {
    return (
      <Document
        author="Comitty"
        keywords="comitty, ticket, event"
        subject={"Vos tickets pour " + props.eventName}
        title="Tickets"
      >
        {props.tickets.map((ticket, index) => (
          <ResumeComponent
            key={props.qrCodesInfo[index].id || index}
            size="A4"
            participantId={props.qrCodesInfo[index].id}
            qrcode={props.qrCodesInfo[index].qrcode}
            eventImage={logo}
            details={props.details}
            eventName={props.eventName}
            tickets={[ticket]}
            eventDescription={props?.eventDescription}
            eventBannerUrl={props?.eventBannerUrl}
            eventLogoUrl={props?.eventLogoUrl}
            lang={lang}
          />
        ))}
      </Document>
    );
  }

  return (
    <Document
      author="Comitty"
      keywords="comitty, ticket, event"
      subject={"Vos tickets pour " + props.eventName}
      title="Tickets"
    >
      <ResumeComponent
        size="A4"
        participantId={props.qrCodesInfo.id}
        qrcode={props.qrCodesInfo.qrcode}
        eventImage={logo}
        tickets={props.tickets}
        details={props.details}
        eventName={props.eventName}
        eventDescription={props?.eventDescription}
        eventBannerUrl={props?.eventBannerUrl}
        eventLogoUrl={props?.eventLogoUrl}
        lang={lang}
      />
    </Document>
  );
};

export default TicketModel;
